import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FontLoader } from 'three/addons/loaders/FontLoader.js'
import {TextGeometry} from 'three/addons/geometries/TextGeometry.js'

/**
 * Base
 */


/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()
const matCapTexture = textureLoader.load('/textures/matcaps/3.png')
const matCapTexture1 = textureLoader.load('/textures/matcaps/8.png')


/**
 * Sizes
 */


/**
 * Font loader
 */
const fontLoader = new FontLoader()
fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    function (font) {
        const textGeometry = new TextGeometry(
            '           Hello!\nDrishti`s Animations',
            {
                font : font,
                size : 0.5,
                height : 0.2,
                curveSegments : 5,
                bevelEnabled : true,
                bevelThickness : 0.03,
                bevelSize : 0.02,
                bevelOffset : 0,
                bevelSegments : 4
            }
        )

        textGeometry.center()
        const textMaterial = new THREE.MeshMatcapMaterial()
        textMaterial.matcap = matCapTexture
        const text = new THREE.Mesh(textGeometry,textMaterial)
        scene.add(text)

        const donutGeometry = new THREE.TorusGeometry(0.2,0.2,20,45)
        const donutMaterial = new THREE.MeshMatcapMaterial()
        donutMaterial.matcap = matCapTexture1

        const cubeGeometry = new THREE.BoxGeometry(0.5,0.5,0.5)
        const cubeMaterial = new THREE.MeshNormalMaterial()
        // cubeMaterial.matcap = matCapTexture1


        for(let i=0;i<70;i++){
            const donut = new THREE.Mesh(donutGeometry,donutMaterial)

            donut.position.x = (Math.random()-0.5)*10
            donut.position.y = (Math.random()-0.5)*10
            donut.position.z = (Math.random()-0.5)*10

            donut.rotation.x = Math.random() * Math.PI
            donut.rotation.y = Math.random() * Math.PI

            const scale = Math.random()
            donut.scale.set(scale,scale,scale)

            scene.add(donut)
        }
        for(let i=0;i<70;i++){
            const cube = new THREE.Mesh(cubeGeometry,cubeMaterial)

            cube.position.x = (Math.random()-0.5)*10
            cube.position.y = (Math.random()-0.5)*10
            cube.position.z = (Math.random()-0.5)*10

            cube.rotation.x = Math.random() * Math.PI
            cube.rotation.y = Math.random() * Math.PI

            const scale = Math.random()
            cube.scale.set(scale,scale,scale)

            scene.add(cube)
        }

    }
)

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Axes Helper
const axesHelper = new THREE.AxesHelper()
// scene.add(axesHelper)


const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})


/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update(elapsedTime)

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
controls.autoRotate = true